export default String.raw`
.widget {
  $width: 477px;
  position: fixed;
  z-index: 8888;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: $width;
  height: 168px;
  padding: 24px 24px 24px 0;
  column-gap: 24px;
  background-color: $bgColor;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.20);

  &__close {
    position: absolute;
    right: 3px;
    top: 3px;
    width: 24px;
    height: 24px;
    visibility: hidden;

    svg {
      fill: $bgColorFont;
      width: 24px;
      height: 24px;
    }
  }

  &__outlier {
    width: 40px;
    height: 168px;
    display: flex;
    align-items: center;

    &-content {
      position: relative;
      left: -64px;
      display: flex;
      @include button;
      min-width: 168px;
      min-height: 40px;
      width: 168px;
      height: 40px;
      padding: 8px 12px 8px 24px;
      justify-content: space-between;
      align-items: center;
      rotate: -90deg;
      background-color: $btnSolidBgColor;
      color: $btnSolidTextColor;
      border-radius: 8px 8px 0 0;

      span {
        word-wrap: break-word;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      &-icon {
        min-width: 12px;
        min-height: 12px;
        width: 12px;
        height: 12px;
        fill: $btnSolidTextColor;
        rotate: -90deg;
      }
    }
  }

  &__image {
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 120px;
      min-width: 120px;
      max-height: 120px;
      border-radius: 8px;
      object-fit: cover;
    }
  }

  &__content {
    width: 245px;

    p {
      @include subtitle-medium;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      margin-bottom: 10px
    }

    &-button {
      @include button;
      width: 115px;
      height: 40px;
    }
  }

  $parent: &;

  &.rightBottom {
    left: calc(100% - 40px);
    bottom: 20%;
    transition: left 0.5s;
    border-radius: 12px 0 0 12px;

    &.clicked {
      left: calc(100% - $width);

      #{$parent}__outlier {
        &-content {
          &-icon {
            rotate: 90deg;
          }
        }
      }
    }
  }

  &.rightTop {
    left: calc(100% - 40px);
    top: 20%;
    transition: left 0.5s;
    border-radius: 12px 0 0 12px;

    &.clicked {
      left: calc(100% - $width);

      #{$parent}__outlier {
        &-content {
          &-icon {
            rotate: 90deg;
          }
        }
      }
    }
  }

  &.leftTop {
    right: calc(100% - 40px);
    top: 20%;
    transition: right 0.5s;
    flex-direction: row-reverse;
    padding: 24px 0 24px 24px;
    border-radius: 0 12px 12px 0;

    #{$parent}__image {
      order: 2;
    }

    #{$parent}__outlier {
      &-content {
        border-radius: 8px 8px 0 0;
        rotate: 90deg;
      }
    }

    &.clicked {
      right: calc(100% - $width);

      #{$parent}__outlier {
        &-content {
          &-icon {
            rotate: 90deg;
          }
        }
      }
    }
  }

  &.leftBottom {
    right: calc(100% - 40px);
    bottom: 20%;
    transition: right 0.5s;
    flex-direction: row-reverse;
    padding: 24px 0 24px 24px;
    border-radius: 0 12px 12px 0;

    #{$parent}__image {
      order: 2;
    }

    #{$parent}__outlier {
      &-content {
        border-radius: 8px 8px 0 0;
        rotate: 90deg;
      }
    }

    &.clicked {
      right: calc(100% - $width);

      #{$parent}__outlier {
        &-content {
          &-icon {
            rotate: 90deg;
          }
        }
      }
    }
  }
}
`